<!-- Empty state, not connected yet -->
@if ((inboxState == null && loading == false) || inboxState == "deleted") {
  <div class="empty-state text-center">
    <img
      src="/assets/img/email-empty-state.svg"
      alt="Illustration of a woman using email"
    />
    <h3 class="mt-5">Connect your email account</h3>
    <p>
      Once you've connected your email account, you'll be <br />able to receive
      emails, convert emails to jobs and more.
    </p>
    <div class="buttons mt-5">
      <div class="dropdown" dropdown style="display: inline-block">
        <a data-toggle="dropdown" dropdownToggle class="btn btn-primary me-3"
          >Connect account <i class="feather chevron-down"></i
        ></a>
        <ul
          class="dropdown-menu"
          *dropdownMenu
          role="menu"
          aria-labelledby="button-basic"
          style="width: 95%"
        >
          <li (click)="getAuthUrl('google')" role="menuitem">
            <a class="dropdown-item">Google</a>
          </li>
          <li (click)="getAuthUrl('outlook')" role="menuitem">
            <a class="dropdown-item">Microsoft</a>
          </li>
        </ul>
      </div>

      <!-- <a href="#" class="btn btn-primary-light">Learn more</a> -->
    </div>
  </div>
}
@if (inboxState == "syncing" && loading == false) {
  <div class="empty-state text-center">
    <img
      src="/assets/img/email-empty-state.svg"
      alt="Illustration of a woman using email"
    />
    <h3 class="mt-5">Syncing your emails</h3>
    <p>
      We are synchronizing your email box. This takes at least a few minutes.<br />
      Please return to this page in a few minutes and hit Refresh on your
      browser to see if the sync process is complete.
    </p>
  </div>
}

<!-- Connected -->
@if (inboxState == "connected") {
  <div class="inbox-wrapper">
    <!-- Sidebar -->
    <div class="inbox-sidebar">
      <h3>Inbox</h3>

      <button
        class="btn btn-primary my-3 mx-2"
        (click)="newEmailState = 'default'"
      >
        <i class="tio-edit"></i>
        <span style="font-size: 1rem; margin-left: 8px">Compose</span>
      </button>

      <!-- <div class="menu">
      <a class="menu-item active"> <i class="tio-email"></i> Emails </a>
      <a class="menu-item"> <i class="tio-chat_outlined"></i> Messages </a>
    </div> -->

      <div class="menu">
        <div class="email-account" [tooltip]="inboxAddress">
          {{ inboxAddress }}
        </div>
        <a
          class="menu-item"
          [ngClass]="{ active: mailbox == 'PRIORITY' }"
          (click)="changeMailbox('PRIORITY')"
        >
          <i class="tio-inbox"></i> Inbox (Priority)
        </a>
        <a
          class="menu-item"
          [ngClass]="{ active: mailbox == 'OTHER' }"
          (click)="changeMailbox('OTHER')"
        >
          <i class="tio-inboxes"></i> Inbox (Recent)
        </a>
        <a
          class="menu-item"
          [ngClass]="{ active: mailbox == 'NOT_MATCHED' }"
          (click)="changeMailbox('NOT_MATCHED')"
        >
          <i class="tio-inboxes"></i> Inbox (Older)
        </a>
        <a
          class="menu-item"
          [ngClass]="{ active: mailbox == 'SENT' }"
          (click)="changeMailbox('SENT')"
        >
          <i class="tio-send_outlined"></i> Sent
        </a>
        <a
          class="menu-item"
          [ngClass]="{ active: mailbox == 'ALL' }"
          (click)="changeMailbox('ALL')"
        >
          <i class="tio-email"></i> All
        </a>
      </div>

      <div class="menu">
        <div class="email-account">Settings</div>
        <a
          class="menu-item"
          [ngClass]="{ active: mailbox == 'SETTINGS' }"
          (click)="changeMailbox('SETTINGS')"
        >
          <i class="tio-settings"></i> Email settings
        </a>
      </div>
    </div>

    <!-- Email list -->
    @if (mailbox !== "SETTINGS") {
      <div class="inbox-list-wrapper">
        <!-- <div class="inbox-list-header">
      <input type="text" class="form-control" placeholder="Search" />
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_945_2265)">
          <path
            d="M4 6H11"
            stroke="#2A3344"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4 12H11"
            stroke="#2A3344"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4 18H13"
            stroke="#2A3344"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15 9L18 6L21 9"
            stroke="#2A3344"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18 6V18"
            stroke="#2A3344"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_945_2265">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div> -->
        <div class="ch-tabs mt-4" style="margin: 0 12px">
          <div
            [ngClass]="{ active: mailbox == 'PRIORITY' }"
            (click)="changeMailbox('PRIORITY')"
          >
            Priority
          </div>
          <div
            [ngClass]="{ active: mailbox == 'OTHER' }"
            (click)="changeMailbox('OTHER')"
          >
            Recent
          </div>
          <div
            [ngClass]="{ active: mailbox == 'NOT_MATCHED' }"
            (click)="changeMailbox('NOT_MATCHED')"
          >
            Older
          </div>
          <div class="w-full text-right">
            <i
              (click)="refreshEmails()"
              [ngClass]="{ rotate: refreshing }"
              class="tio-refresh refresh-icon"
              tooltip="Refresh mailbox"
              placement="left"
            ></i>
          </div>
        </div>
        <div class="inbox-list">
          @for (thread of threads; track thread.id) {
            <div
              class="inbox-list-item"
              [ngClass]="{
                read: thread.unread == false,
                unread: thread.unread,
                active: thread.uuid == selectedThread?.uuid,
              }"
              (click)="getEmailThread(thread)"
            >
              <div class="header">
                <div class="left">
                  <div class="sender">{{ thread.from_email["name"] }}</div>
                </div>
                <div class="right">
                  @if (thread.thread_messages_count > 0) {
                    <div
                      class="inbox-badge"
                      tooltip="{{ thread.thread_messages_count }} replies"
                    >
                      <svg
                        width="14"
                        height="15"
                        viewBox="0 0 14 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.25008 8.66667L2.91675 6.33333L5.25008 4"
                          stroke="#151C29"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2.91675 6.33333H9.33341C9.95225 6.33333 10.5457 6.57916 10.9833 7.01675C11.4209 7.45433 11.6667 8.04782 11.6667 8.66666C11.6667 9.2855 11.4209 9.87899 10.9833 10.3166C10.5457 10.7542 9.95225 11 9.33341 11H8.75008"
                          stroke="#151C29"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      {{ thread.thread_messages_count }}
                    </div>
                  }
                  <div class="unread" tooltip="Unread"></div>
                  <div class="date" [tooltip]="thread.last_message_received_timestamp | amDateFormat:'MM/DD/YYYY HH:mm'">
                    {{ thread.last_message_received_timestamp | amTimeAgo }}
                  </div>
                </div>
              </div>
              <div class="subject">{{ thread.subject }}</div>
              <div class="preview">
                {{ thread.snippet }}
              </div>
            </div>
          }

          <p-paginator
            (onPageChange)="onPageChange($event)"
            [first]="start"
            [rows]="rows"
            [totalRecords]="totalRecords"
            [rowsPerPageOptions]="[10, 20, 50]"
          ></p-paginator>
          <!-- <div class="inbox-list-item active">
        <div class="header">
          <div class="left">
            <div class="sender">Fabian Cabau</div>
          </div>
          <div class="right">
            <div class="inbox-badge" tooltip="2 attachments">
              <svg
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.75007 4.58333L4.9584 8.375C4.72634 8.60706 4.59597 8.92181 4.59597 9.25C4.59597 9.57819 4.72634 9.89294 4.9584 10.125C5.19047 10.3571 5.50522 10.4874 5.8334 10.4874C6.16159 10.4874 6.47634 10.3571 6.7084 10.125L10.5001 6.33333C10.9642 5.8692 11.2249 5.23971 11.2249 4.58333C11.2249 3.92696 10.9642 3.29746 10.5001 2.83333C10.0359 2.3692 9.40645 2.10846 8.75007 2.10846C8.09369 2.10846 7.4642 2.3692 7.00007 2.83333L3.2084 6.625C2.51221 7.32119 2.12109 8.26543 2.12109 9.25C2.12109 10.2346 2.51221 11.1788 3.2084 11.875C3.9046 12.5712 4.84884 12.9623 5.8334 12.9623C6.81797 12.9623 7.76221 12.5712 8.4584 11.875L12.2501 8.08333"
                  stroke="#151C29"
                  stroke-width="1.4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              2
            </div>
            <div class="inbox-badge" tooltip="1 reply">
              <svg
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.25008 8.66667L2.91675 6.33333L5.25008 4"
                  stroke="#151C29"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M2.91675 6.33333H9.33341C9.95225 6.33333 10.5457 6.57916 10.9833 7.01675C11.4209 7.45433 11.6667 8.04782 11.6667 8.66666C11.6667 9.2855 11.4209 9.87899 10.9833 10.3166C10.5457 10.7542 9.95225 11 9.33341 11H8.75008"
                  stroke="#151C29"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              1
            </div>
            <div class="unread" tooltip="Unread"></div>
            <div class="date">3h</div>
          </div>
        </div>
        <div class="subject">Spatika Lingam or Crystal Lingam</div>
        <div class="preview">
          There are many different varieties of sphatikam. High quality quartz
          crystals are single-crystal silica with optical or electronic
          properties that make them suitable for hardstone carvings.
        </div>
      </div> -->
          <!-- <div class="inbox-list-item unread">
        <div class="header">
          <div class="left">
            <div class="sender">Alana Dobbrunz</div>
          </div>
          <div class="right">
            <div class="inbox-badge" tooltip="2 attachments">
              <svg
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.75007 4.58333L4.9584 8.375C4.72634 8.60706 4.59597 8.92181 4.59597 9.25C4.59597 9.57819 4.72634 9.89294 4.9584 10.125C5.19047 10.3571 5.50522 10.4874 5.8334 10.4874C6.16159 10.4874 6.47634 10.3571 6.7084 10.125L10.5001 6.33333C10.9642 5.8692 11.2249 5.23971 11.2249 4.58333C11.2249 3.92696 10.9642 3.29746 10.5001 2.83333C10.0359 2.3692 9.40645 2.10846 8.75007 2.10846C8.09369 2.10846 7.4642 2.3692 7.00007 2.83333L3.2084 6.625C2.51221 7.32119 2.12109 8.26543 2.12109 9.25C2.12109 10.2346 2.51221 11.1788 3.2084 11.875C3.9046 12.5712 4.84884 12.9623 5.8334 12.9623C6.81797 12.9623 7.76221 12.5712 8.4584 11.875L12.2501 8.08333"
                  stroke="#151C29"
                  stroke-width="1.4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              1
            </div>
            <div class="unread" tooltip="Unread"></div>
            <div class="date">1d</div>
          </div>
        </div>
        <div class="subject">Spatika Lingam or Crystal Lingam</div>
        <div class="preview">
          There are many different varieties of sphatikam. High quality quartz
          crystals are single-crystal silica with optical or electronic
          properties that make them suitable for hardstone carvings.
        </div>
      </div> -->
        </div>
      </div>
    }

    <!-- Email view -->
    @if (mailbox !== "SETTINGS") {
      <div
        class="inbox-email-view-wrapper"
        [ngClass]="{ 'component-loading': loading }"
      >
        <email-content
          [thread]="selectedThread"
          [mailbox]="mailbox"
        ></email-content>
      </div>
    }

    <!-- Email settings -->
    @if (mailbox == "SETTINGS") {
      <div class="p-4">
        <h3 class="pt-3">Email settings</h3>
        <h4 class="mt-5">Greetings</h4>
        <p>It will be displayed right before your email body</p>
        <textarea
          name=""
          id=""
          [(ngModel)]="settings.greeting"
          cols="30"
          rows="1"
          class="form-control"
        ></textarea>
        <hr />
        <h4 class="mt-5">Signoff and Signature</h4>
        <p>It will be displayed at the end of the emails you send.</p>

        <!-- <ejs-richtexteditor
      class="form-control"
      id="testing"
      [(value)]="settings.signature"
      [insertImageSettings]="jobsService.insertImageSettings"
      (imageUploading)="jobsService.addHeaders($event)"
      (imageUploadSuccess)="jobsService.onUploadSuccess($event)"
      [toolbarSettings]="jobsService.clientTaskToolbarSettings"
    >
    </ejs-richtexteditor> -->
        <p-editor
          [(ngModel)]="settings.signature"
          [style]="{ height: '320px' }"
        >
          <p-header>
            <span class="ql-formats">
              <select class="ql-font ql-picker">
                <option selected>Sans Serif</option>
                <option value="serif">Serif</option>
                <option value="monospace">Monospace</option>
              </select>
            </span>
            <span class="ql-formats">
              <button class="ql-bold" aria-label="Bold"></button>
              <button class="ql-italic" aria-label="Italic"></button>
              <button class="ql-underline" aria-label="Underline"></button>
              <button class="ql-strike" aria-label="Strike"></button>
            </span>
            <span class="ql-formats">
              <select
                title="Text Color"
                class="ql-color"
                defaultValue="rgb(0, 0, 0)"
              ></select>
              <span class="ql-format-separator"></span>
              <select
                title="Background Color"
                class="ql-background"
                defaultValue="rgb(255, 255, 255)"
              ></select>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="ordered" type="button"></button>
              <button class="ql-list" value="bullet" type="button"></button>
            </span>
            <span class="ql-formats">
              <button aria-label="Link" class="ql-link"></button>
              <button aria-label="Image" class="ql-image"></button>
            </span>
          </p-header>
        </p-editor>
        <button class="btn btn-primary mt-5" (click)="saveInboxSettings()">
          Save Changes
        </button>
        <button
          class="btn btn-danger mt-5"
          (click)="openRemoveConnectionModal(removeConnectionModal)"
        >
          Remove Connection
        </button>
      </div>
    }

    <ng-template #createJobModal>
      <div class="modal-header">
        <button
          type="button"
          class="btn-close"
          (click)="bsModalRef.hide()"
          aria-label="Close"
        >
          <i class="feather x"></i>
        </button>
        <h4 class="modal-title">Create Job</h4>
      </div>
      <div class="modal-body text-center create-job-modal">
        <i class="feather clipboard x3" style="color: #0075ff"></i>
        <form name="job-settings">
          <div class="row text-left">
            <div class="col-md-12">
              @if (accountants != null) {
                <div class="form-group assignee-wrapper">
                  <label style="margin-top: 15px">Assignee</label>
                  <div
                    class="assignee"
                    dropdown
                    [autoClose]="true"
                    dropdownToggle
                  >
                    <div class="avatar">
                      <img [src]="assignedTo?.pictureUrl" />
                    </div>
                    <div
                      class="username"
                      [tooltip]="
                        assignedTo == null ? 'Select' : assignedTo?.full_name
                      "
                      placement="top"
                    >
                      {{
                        assignedTo == null ? "Select" : assignedTo?.full_name
                      }}
                    </div>
                    <ul
                      id="basic-link-dropdown"
                      *dropdownMenu
                      class="dropdown-menu"
                      role="menu"
                      aria-labelledby="basic-link"
                    >
                      @for (accountant of accountants; track accountant.id) {
                        <li (click)="setAssignee(accountant.user)">
                          <a>
                            <div class="avatar">
                              <img [src]="accountant.user.pictureUrl" />
                            </div>
                            <div
                              class="username"
                              [tooltip]="accountant.user.full_name"
                              placement="top"
                            >
                              {{ accountant.user.full_name }}
                            </div>
                          </a>
                        </li>
                      }
                    </ul>
                    <i class="feather chevron-down"></i>
                  </div>
                </div>
              }
            </div>
          </div>

          <div class="row text-left">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Start date</label>
                    <p-datepicker
                      [(ngModel)]="targetStartDate"
                      [dateFormat]="datepickerFormat"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Due date</label>
                    <p-datepicker
                      [(ngModel)]="dueDate"
                      [dateFormat]="datepickerFormat"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <div
          class="btn btn-default pull-left"
          aria-label="Cancel"
          (click)="bsModalRef.hide()"
        >
          Cancel
        </div>
        <button class="btn btn-primary pull-right" (click)="createJob()">
          Create Job
        </button>
      </div>
    </ng-template>
  </div>
} @else if (inboxState == "auth_error" && loading == false) {
  <div class="text-center">
    <i class="tio-sync" style="font-size: 64px; opacity: 0.3"></i>
    <h4 class="mb-2 mt-4" style="color: #000">Auth Error</h4>
    <p class="mb-4">
      Your email connection has failed. Please check out our help center for more
      information and then click on Retry Connection.
    </p>

    <button class="btn btn-primary" (click)="retryConnection()">
      Retry Connection
    </button>
  </div>
}

<ng-template #removeConnectionModal>
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      (click)="bsModalRef.hide()"
      aria-label="Close"
    >
      <i class="feather x"></i>
    </button>
    <h4 class="modal-title">Remove Connection</h4>
  </div>
  <div class="modal-body text-center">
    <i class="feather alert-triangle x3" style="color: #bd1105"></i>
    <p>
      Are you sure you want to remove your email connection? All emails will be
      deleted from Client Hub
    </p>
    <div class="btn btn-danger btn-block" (click)="removeEmailConnection()">
      Remove
    </div>
  </div>
  <div class="modal-footer">
    <div
      class="btn btn-default btn-block"
      aria-label="Cancel"
      (click)="bsModalRef.hide()"
    >
      Cancel
    </div>
  </div>
</ng-template>

<div
  class="new-email-wrapper"
  *ngIf="newEmailState != 'closed'"
  [ngClass]="{
    minimized: newEmailState == 'minimized',
    maximized: newEmailState == 'maximized',
  }"
>
  <div class="header">
    <h4>New email</h4>
    <div class="wrapper-icons">
      <svg
        *ngIf="newEmailState != 'minimized'"
        (click)="newEmailState = 'minimized'"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 18H19"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        *ngIf="newEmailState == 'minimized'"
        (click)="newEmailState = 'default'"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 6H19"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        *ngIf="newEmailState != 'maximized'"
        (click)="newEmailState = 'maximized'"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 6H18V10"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 18H6V14"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 6L13.5 10.5"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 18L10.5 13.5"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        *ngIf="newEmailState == 'maximized'"
        (click)="newEmailState = 'default'"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5 10.5L13.5 10.5L13.5 6.5"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.5 10.5L18 6"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.5 13.5L10.5 13.5L10.5 17.5"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.5 13.5L6 18"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        (click)="newEmailState = 'closed'"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.8501 16.44C17.897 16.4865 17.9342 16.5418 17.9595 16.6027C17.9849 16.6636 17.998 16.729 17.998 16.795C17.998 16.861 17.9849 16.9263 17.9595 16.9873C17.9342 17.0482 17.897 17.1035 17.8501 17.15L17.1501 17.85C17.1036 17.8968 17.0483 17.934 16.9874 17.9594C16.9265 17.9848 16.8611 17.9979 16.7951 17.9979C16.7291 17.9979 16.6637 17.9848 16.6028 17.9594C16.5419 17.934 16.4866 17.8968 16.4401 17.85L12.0001 13.41L7.5601 17.85C7.51361 17.8968 7.45831 17.934 7.39738 17.9594C7.33646 17.9848 7.2711 17.9979 7.2051 17.9979C7.13909 17.9979 7.07374 17.9848 7.01281 17.9594C6.95188 17.934 6.89658 17.8968 6.8501 17.85L6.1501 17.15C6.10323 17.1035 6.06604 17.0482 6.04065 16.9873C6.01527 16.9263 6.0022 16.861 6.0022 16.795C6.0022 16.729 6.01527 16.6636 6.04065 16.6027C6.06604 16.5418 6.10323 16.4865 6.1501 16.44L10.5901 12L6.1501 7.55997C6.10323 7.51349 6.06604 7.45819 6.04065 7.39726C6.01527 7.33633 6.0022 7.27098 6.0022 7.20497C6.0022 7.13897 6.01527 7.07362 6.04065 7.01269C6.06604 6.95176 6.10323 6.89646 6.1501 6.84997L6.8501 6.14997C6.89658 6.10311 6.95188 6.06591 7.01281 6.04053C7.07374 6.01514 7.13909 6.00208 7.2051 6.00208C7.2711 6.00208 7.33646 6.01514 7.39738 6.04053C7.45831 6.06591 7.51361 6.10311 7.5601 6.14997L12.0001 10.59L16.4401 6.14997C16.4866 6.10311 16.5419 6.06591 16.6028 6.04053C16.6637 6.01514 16.7291 6.00208 16.7951 6.00208C16.8611 6.00208 16.9265 6.01514 16.9874 6.04053C17.0483 6.06591 17.1036 6.10311 17.1501 6.14997L17.8501 6.84997C17.897 6.89646 17.9342 6.95176 17.9595 7.01269C17.9849 7.07362 17.998 7.13897 17.998 7.20497C17.998 7.27098 17.9849 7.33633 17.9595 7.39726C17.9342 7.45819 17.897 7.51349 17.8501 7.55997L13.4101 12L17.8501 16.44Z"
          fill="black"
        />
      </svg>
    </div>
  </div>
  <email-form
    class="new-email-form"
    [composeMode]="true"
    [newEmailMode]="true"
    (cancelCompose)="handleCancelCompose()"
  ></email-form>
</div>
